// extracted by mini-css-extract-plugin
export default {"custom-table":"CustomTable_custom-table__NSa8d"};